<template>
    <div class="manageQuery">
      <div class="queryHeader">
        <van-nav-bar
          title="数据查询"
          left-text="返回"
          left-arrow
          @click-left="goBack"
        />
      
       <van-row>
          <van-tabs v-model="active">
            <div class="content">
              <van-tab v-for="item in titleList" :key="item.index" :title="item.title">
              <manageUser v-if="item.index == '1'"/>
              <serveManageUser v-if="item.index == '2'"/>
              <!-- <overdue v-if="item.index == '3'"/>
              <plateInStock v-if="item.index == '4'"/>
              <history v-if="item.index == '5'"/> -->
            </van-tab>
            </div>
          </van-tabs>
      </van-row>
      </div>
    </div>
  </template>
  
  <script>
  import {Tab,Tabs} from 'vant'
  import manageUser from '@/components/user/manage.vue'
  import serveManageUser from '@/components/user/satation.vue'
  export default {
    // mounted(){
    //   this.echartsInit()
    // },
    components:{
      manageUser,
      serveManageUser
    },
    filters:{
  
    },
    data(){
      return{
       active:0,// 0管理员用户，1服务站用户
       titleList:[
                  {'index':'1','title':'管理员用户'},
                  {'index':'2','title':'服务站用户'},
              ]
      }
    },
    methods:{
      // 返回
      goBack(){
        console.log('返回管理员首页');
        this.$router.push('/manager')
      },
  
     
    }
  
  }
  </script>
  
  <style lang="scss" >
  .manageQuery{
    .van-nav-bar .van-icon{
      color: #0283ef;
    }
    .van-nav-bar__text{
      color: #0283ef;
    }
    .queryHeader{
      width: 100%;
      height: 8%;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 999;
      background-color: #fff;
      .van-tab--active{
        color: #0283ef;
      }
      .van-tabs__line{
        background-color: #0283ef;
      }
    }
    .content{
      overflow-y: auto;//内容溢出垂直滚动
      height: calc(100vh - 110px);//内容区高度，确保占满剩余可视窗口
    }
    .van-tabs__wrap--scrollable .van-tab{
        padding: 0;
      }
  
  }
  
  </style>